import { isDeleteOrBackspace } from '@/helpers/utils';
export const inputFocus = (el) => {
    var _a, _b;
    if (isDeleteOrBackspace(el.key)) {
        const next = el.currentTarget.tabIndex - 1;
        if (next > -1) {
            const nextEl = (_a = el.currentTarget.form) === null || _a === void 0 ? void 0 : _a.elements[next];
            nextEl === null || nextEl === void 0 ? void 0 : nextEl.focus();
        }
    }
    else {
        const next = el.currentTarget.tabIndex + 1;
        if (next < 6) {
            const nextEl = (_b = el.currentTarget.form) === null || _b === void 0 ? void 0 : _b.elements[next];
            nextEl === null || nextEl === void 0 ? void 0 : nextEl.focus();
        }
    }
};
